<template>
  <v-container class="container">
    <v-card class="mt-5">
      <v-card-text>
        <v-row>
          <v-col>
            <v-menu
            ref="menuFechaCarga"
            v-model="menuFechaCarga"
            :close-on-content-click="false"
            transition="scale-transition"
            offset-y
            max-width="290px"
            min-width="auto"
          >
            <template v-slot:activator="{ on, attrs }">
              <v-text-field
                style="width: 50%;"
                outlined
                v-model="fechaCarga"
                label="Selección fecha de carga"
                persistent-hint
                append-icon="mdi-calendar"
                v-bind="attrs"
                v-on="on"
              ></v-text-field>
            </template>
            <v-date-picker
              v-model="fechaCarga"
              no-title
              @input="menuFechaCarga = false"
            ></v-date-picker>
          </v-menu>
          </v-col>
          <v-col>
            <v-text-field
            v-model="folioFilter"
            type="number"
            label="folio"

            ></v-text-field>
          </v-col>
          <v-col class="d-flex justify-end">
            <v-btn color="primary" @click="getMultas()" class="d-flex justify-end">Consultar estado</v-btn>
          </v-col>

        </v-row>
        <div>
          <v-data-table
            :headers="headers"
            :items="multas"
            :items-per-page.sync="limit"
            :page.sync="offset"
            :server-items-length="total"
            class="caption"
            @pagination="getMultas()"
          >
          <template v-slot:[`item.nombre_multado`]="{ item }">
            {{ item.nombres  }} {{ item.paterno }} {{ item.materno }}
          </template>
          <template v-slot:[`item.rut`]="{ item }">
              {{ item.rut }}-{{ item.dv }}
            </template>
          <template v-slot:[`item.descargar`]="{ item }">
            <div class="d-flex" v-if="item.estado=='ENVIADA' && this.showButtons(4)">
              <v-tooltip bottom>
                <template v-slot:activator="{ on, attrs }">
                  <v-icon
                    color="black"
                    style="font-size: 35px;"
                    @click="Descargar(item)"
                    class="mr-2"
                    v-bind="attrs"
                    v-on="on"
                    >mdi-file-document-remove-outline</v-icon
                  >
                </template>
                <span>Descargar</span>
              </v-tooltip>
            </div>
          </template>
          </v-data-table>
        </div>
      </v-card-text>
    </v-card>
  </v-container>
</template>

<script>
import { mapMutations , mapGetters} from "vuex";
import {MultasService} from "../../util/Api/Multas/calls"
import { Loading } from "element-ui";
import Swal from "sweetalert2";
export default {
  name: "EstadoMultaComponents",
  components: {
  },
  data() {
    return {
      status: false,
      showDialog: false,
      menuFechaCarga: false,
      fechaCarga: null,
      total:0,
      limit:10,//la cantidad
      offset:1,//la pagina
      subdireccionFilter:null,
      folioFilter:null,

      headers: [
        { text: "NOMBRE O RAZON SOCIAL", value: "nombre_multado"  },
        { text: "RUT", value: "rut" },
        { text: "TIPO MONEDA", value: "moneda" },
        { text: "FOLIO", value: "folio" },
        { text: "MONTO MULTA", value: "montomulta" },
        { text: "FECHA EMISION", value: "fechaemision" },
        { text: "FECHA ENVIO", value: "fechaenvio" },
        { text: "SUBDIRECCIÓN", value: "subdireccion" },
        { text: "TRANSACCION N°", value: "id_transaccion" },
        { text: "ESTADO", value: "estado" },
        { text: "Descargar", value: "descargar" },
      ],
      multas: [],
    };
  },
  computed: {
      ...mapGetters(["getPerfil"]),
    },
  methods: {
    ...mapMutations("estadoMulta", ["setDetalle"]),

      showButtons(accesoId){
      // Verificar que getPerfil existe
      if (!this.getPerfil) {
        return false;
      }
      // Verificar que accesos existe y es un array antes de usar some
      return this.getPerfil.accesos && Array.isArray(this.getPerfil.accesos) &&
        this.getPerfil.accesos.some(acceso => acceso.id === accesoId);
    },

    async Descargar(data) {
      try {
        this.loadingInstance = Loading.service({
          fullscreen: true,
          text: "Cargando..",
          background: "rgba(0, 0, 0, 0.8)",
        });
        const params={
          folio:data.folio,
          idusuario:this.getPerfil.id
        }
        const resp = await MultasService.descargar(params);

        this.loadingInstance.close();
      } catch (error) {
        this.loadingInstance.close();
        console.log("error", error);
        Swal.fire({
          type: "error",
          html: `Error al cargar los Multas: ${error}`,
        });
      }
    console.log(data);

    },


    async getMultas(){
      try {
        this.loadingInstance = Loading.service({
          fullscreen: true,
          text: "Cargando..",
          background: "rgba(0, 0, 0, 0.8)",
        });

        const params={
          idsubdireccion:this.getPerfil.subdireccion_id,
          limit:this.limit !==-1 ? this.limit : 999999 ,//la cantidad
          offset: this.limit !==-1 ? (this.offset-1)*this.limit : 0,//la pagina-1 * limit pa
          fromDate:this.fechaCarga ? `${this.fechaCarga}T00:00:00.000Z`: null,
          toDate:this.fechaCarga ? `${this.fechaCarga}T23:59:59.999Z`: null,
          folio:this.folioFilter,
        }

        this.multas = await MultasService.getAll(params);

        this.multas.length ? this.total= Number(this.multas[0].total) : null
        this.loadingInstance.close();
      } catch (error) {
        this.loadingInstance.close();
        console.log("error", error);
        Swal.fire({
          type: "error",
          html: `Error al cargar los Multas: ${error}`,
        });
      }
    } 
  },
};
</script>

<style scoped>
.container {
  text-align: start !important;
}
</style>
